export default {
    methods: {
        getApplication(application_id) {
            if (this.applications.length > 0) {
                const application = this.applications.filter(function(select_item) {
                    return select_item.id === application_id;
                })
                    return application[0];
                } else {
                    return [];
                }
            },
    }
    
}